<template>
    <div class="card">
        <div class="card-body">
            <table class="table table-striped table-hover">
                <thead>
                    <tr>
                        <th>Название</th>

                        <th style="width: 100px" class="d-none d-sm-table-cell">Вместимость</th>
                        <th colspan="2" class="d-sm-none">Вместимость</th>

                        <th class="action-buttons d-none d-sm-table-cell" />
                    </tr>
                </thead>
                <tbody>
                    <ValidationObserver v-for="(component, index) in components" ref="capacity" :key="component.id" v-slot="{ invalid }" tag="tr">
                        <td>{{ component.name }}</td>

                        <ValidationProvider v-errors.api tag="td" class="form-group flex-fill ml-2" vid="max" rules="integer|min_value:0">
                            <template v-if="index !== editableIndex">
                                <input v-model="component.max" type="hidden">

                                <template v-if="component.max >= 0">{{ component.max }} {{ component.unit | unit }}</template>
                                <template v-else>–</template>
                            </template>

                            <volume-input v-else ref="max" v-model="editable.max" :unit="component.unit" @keydown.enter="update" />
                        </ValidationProvider>

                        <td class="action-buttons">
                            <button v-if="index === editableIndex" type="button" class="btn btn-link p-0" @click.prevent="stopEdit"><i class="tlm-icon-times text-danger" /></button>
                            <button v-if="index === editableIndex" type="button" class="btn btn-link p-0 ml-3" :disabled="invalid" @click.prevent="update"><i class="tlm-icon-check text-success" /></button>
                            <button v-else type="button" class="btn btn-edit" @click.prevent="startEdit(index)" />
                        </td>
                    </ValidationObserver>
                </tbody>

                <tfoot v-if="components.length === 0" class="no-one">
                    <tr>
                        <td colspan="3">Ингредиенты отсутствуют.</td>
                    </tr>
                </tfoot>
            </table>

            <!-- Мобила -->
            <TheModal v-if="editable && $store.state.isMobile" class="d-sm-none nofh" @close="stopEdit">
                <template v-slot:head>{{ editable.name }}</template>

                <ValidationObserver ref="editFormMobile" v-slot="{ invalid }" tag="form" @submit.prevent="updateMobile">
                    <ValidationProvider v-if="!editable.is_composite" v-errors.api tag="div" class="form-group mb-4" vid="max" rules="required|integer|min_value:1">
                        <label>Вместимость</label>
                        <volume-input v-model="editable.max" :unit="editable.unit" class="w-100" />
                    </ValidationProvider>

                    <button type="submit" :disabled="invalid" class="btn btn-primary btn-lg-192 mb-3">Сохранить</button>
                </ValidationObserver>
            </TheModal>
        </div>
    </div>
</template>

<script>
import TheModal from '@/components/TheModal'
import VolumeInput from '@/components/VolumeInput'
import { ValidationProvider, ValidationObserver } from 'vee-validate'

export default {
    components: {
        ValidationObserver,
        ValidationProvider,
        VolumeInput,
        TheModal
    },

    props: {
        components: {
            type: Array,
            default: _ => ([])
        }
    },

    data() {
        return {
            editableIndex: null,
            editable: null
        }
    },

    methods: {
        startEdit(index) {
            this.editableIndex = index
            this.editable = { ...this.components[index] }

            this.$nextTick(function () {
                this.$refs.max[0].focus()
            })
        },

        stopEdit() {
            this.editableIndex = null
            this.editable = null
        },

        async updateMobile(event, a) {
            const isValid = await this.$refs.editFormMobile.validate()

            if (!isValid) {
                return
            }

            this.$emit('update', { ...this.editable })

            this.stopEdit()
        },

        update() {
            this.$emit('update', { ...this.editable })
            this.stopEdit()
        }
    }
}
</script>
